import { render, staticRenderFns } from "./shopfooter.vue?vue&type=template&id=37a110d8"
import script from "./shopfooter.vue?vue&type=script&lang=js"
export * from "./shopfooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports